module.exports = __webpack_public_path__ + "static/media/img5.abf6af6e.jpeg";